<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-11-26                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div class="d-flex align-items-baseline">
    <h1>{{header}}</h1>
    <p class="ml-3"><b-badge>{{filteredLength}}</b-badge> of <b-badge>{{itemsLength}}</b-badge></p>
  </div>

</template>

<script>
export default {
  name: "yega1-list-header",
  props:{
    header:{
      type:String,
      required:true
    },
    itemsLength:{
      type:Number,
      required:true
    },
    filteredLength:{
      type:Number,
      required:true
    },
  }
}
</script>

<style scoped>

</style>
